import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { FiDownload } from "react-icons/fi";

import "./NavigationBar.css";

const NavigationBar = ({ onLanguageToggle, onExportPDF, uiTexts }) => {
  const [showExportLink, setShowExportLink] = useState(true);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      const showExport = params.get("showExport") === "true";
      setShowExportLink(showExport);
    }
  }, []);

  const handleLanguageClick = (e) => {
    e.preventDefault();
    onLanguageToggle();
  };

  const handleExportClick = (e) => {
    e.preventDefault();
    onExportPDF();
  };

  return (
    <>
      <Navbar expand={false} className="navigation-bar" sticky="top">
        <Container className="navbar-container">
          <Nav className="ms-auto">
            {showExportLink && (
              <Nav.Link href="#" onClick={handleExportClick}>
                <FiDownload size={16} />
              </Nav.Link>
            )}
            <Nav.Link href="#" onClick={handleLanguageClick}>
              {uiTexts?.languageToggle}
            </Nav.Link>
          </Nav>
        </Container>
        <div className="nav-border-no-shadow"></div>
      </Navbar>
      <div className="nav-border"></div>
    </>
  );
};

export default NavigationBar;
